module.exports = __webpack_public_path__ + "src/assets/games/47/1.png";